import translationDE from './de/translation.json';
import dealDe from './deal/de.json';
import dealEn from './deal/en.json';
import dealIt from './deal/it.json';
import translationEN from './en/translation.json';
import translationIT from './it/translation.json';
const de = {
  translation: translationDE
};
const it = {
  translation: translationIT
};
const en = {
  translation: translationEN
};
export { de, it, en, dealDe, dealEn, dealIt };